import { render, staticRenderFns } from "./LocalFTPForm.vue?vue&type=template&id=746366de&"
import script from "./LocalFTPForm.vue?vue&type=script&lang=js&"
export * from "./LocalFTPForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports